import { Typography } from "~/common/components";
import {
  ALL_PERSONAL_LIFE_HISTORY_IDS_V3,
  PERSONAL_LIFE_HISTORY_IDS_V3,
  PREVIEW_TITLE_CODES,
} from "~/providers/constants/SummariesExpandableIds";
import Expandable from "../common/Expandable";

export interface PersonalLifeHistoryProps {
  past_personal_history: string;
  educational_history: string;
  family_history: string;
  summary: string;
}

export const PersonalLifeHistoryV3 = ({
  educational_history,
  family_history,
  past_personal_history,
  summary,
}: PersonalLifeHistoryProps) => (
  <Expandable.Wrapper
    code={PREVIEW_TITLE_CODES.PERSONAL_LIFE_HISTORY}
    expandableSections={[...ALL_PERSONAL_LIFE_HISTORY_IDS_V3]}
  >
    <Typography className="border-b border-neutral-80 pb-3">
      {summary}
    </Typography>
    <Expandable.Section
      code={PERSONAL_LIFE_HISTORY_IDS_V3.PAST_PERSONAL_HISTORY}
    >
      {past_personal_history}
    </Expandable.Section>
    <Expandable.Section code={PERSONAL_LIFE_HISTORY_IDS_V3.EDUCATIONAL_HISTORY}>
      {educational_history}
    </Expandable.Section>
    <Expandable.Section
      code={PERSONAL_LIFE_HISTORY_IDS_V3.FAMILY_HISTORY}
      className="border-none pb-0"
    >
      {family_history}
    </Expandable.Section>
  </Expandable.Wrapper>
);
